(function($) {
  $(document).ready(initializeCarousel);

  var carouselInterval;
  var carouselIntervals = {};

  function initializeCarousel() {
    $(".carousel-indicators.enabled").each(wireCarousel);
  }

  // Carousel
  function wireCarousel(j) {
    // find the controls
    var $controls = $(this);
    var $target = $($controls.data("controls"));
    var auto = $controls.data("auto") ? true : false;
    var timeout = $controls.data("auto");
    //$target.addClass("carousel");

    $controls.find(".btn").each(function (i, e) {
      var $button = $(this);
      //var id = $item.closest('.carousel-wrapper').attr('id');
      //var datatarget = id + "-" + (i + 1);
      //var active = i === 1 ? "active" : "";
      $button.click(onCarouselIndicatorClick);
    });

    //$target.attr("data-interval", j);
    $controls.find('.carousel-indicator').eq(0).trigger("click");

    if (auto === true) {
      carouselIntervals[j] = setInterval(function () {
        var index = $controls.find(".active").index();
        var length = $controls.children().length;

        if (index < length - 1) {
          $controls.find(".btn").eq(index + 1).trigger("click");
        } else {
          $controls.find(".btn").eq(0).trigger("click");
        }
      }, $controls.data("auto"));
    }
  }

  function onCarouselIndicatorClick(e) {
    var $button = $(this);
    var $target = $("li[data-control='" + $button.data("target") + "']");
    var $container = $target.closest("ul.carousel");
    var $controls = $button.closest(".carousel-indicators.enabled");
    var $items = $container.find("li");
    var $buttons = $controls.find("button");
    var index = $button.index();
    var interval = parseInt($container.attr("data-interval"));

    $controls.find(".active").removeClass("active");
    $container.find(".render").removeClass("render");
    $target.addClass("render");
    $button.addClass("active");
    $items.removeClass("left right");

    $buttons.each(function (i) {
      if (i < index) $items.eq(i).addClass("left");
      if (i > index) $items.eq(i).addClass("right");
    });

    if (e.originalEvent) clearInterval(carouselIntervals[interval]);
  }

  // No carousel on wide homepage
  $(window).on("resize", function() {
    var mediaQuery = window.matchMedia('(min-width:768px)');
    var isHomePage = false;
    const currentUrl = window.location.pathname;
    if (currentUrl === '/' || currentUrl === '/node/42' || currentUrl === '/home') {
      isHomePage = true;
    }
    var $controls = $(".carousel-indicators");
    var $target = $($controls.data("controls"));
    var $container = $target.closest("ul.carousel");
    var $buttons = $controls.find("button");

    if (mediaQuery.matches && isHomePage === true) {
      $controls.removeClass('enabled').addClass('disabled');
      //$container.addClass('disabled';)
      $controls.removeAttr('data-auto');
    }
    else {
      //$controls.attr('data-auto', '5000');
      $controls.removeClass('disabled').addClass('enabled');
    }
  }).resize();

  /*
   * This stopped video from playing when you slide, but
   * needs YouTube API but that's not how we're loading video
   * So none of this works. Instead we stopped autoplay.
   *

  // Video
  var ytplayer = null;

  // fire when the player is fully loaded
  $(".field--name-field-media-oembed-video iframe").each(function() {
    ytplayer = $(this);
    ytplayer.addEventListener("onStateChange", "onPlayerStateChange");
  });

  // fire when the state of the player changes
  function onPlayerStateChange(state) {
    if(state == 1) {
      // is playing
    }
  }

  function wireYouTubeVideos() {

    if(!ytInitialized) {
      ytInitialized = true;

      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";

      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  window.onYouTubeIframeAPIReady = function() {
    $(".field--name-field-media-oembed-video iframe").each(function() {
      onStateChange();
    });
  }

  function configureVideo() {
    var src = $(this).data("src");
    var id = "video-"+src;
    $(this).attr("id",id);

    var player = new YT.Player(id, {
      height: '315',
      width: '560',
      videoId: src,
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  }

  function onPlayerReady(e) {
    var player = e.target;
  }

  function onPlayerStateChange(e) {
    var player = e.target;
    var $iframe = $(e.target.getIframe());
    var $container = $iframe.closest(".ul");
    var interval = parseInt($container.attr("data-interval"));

    if(e.data == YT.PlayerState.PLAYING) {
      clearInterval(carouselIntervals[interval]);
    }
  }

  *
  */

}(jQuery));

/**
 * BOOTSTRAP CAROUSEL
 * behaves badly
 *

import { Carousel } from '/src/js/_bootstrap';

(() => {
 const mediaQuery = window.matchMedia('(min-width:768px)');

  function showHideCarousel(mediaQuery) {
    const carousels = Array.from(document.getElementsByClassName('carousel'));
    //console.log(carousels);
    carousels.forEach(carousel => {
      const carouselId = carousel.id;
      //console.log(carouselId);
      const currentUrl = window.location.pathname;
      let isHomePage = false;
      if (currentUrl === '/' || currentUrl === '/node/42' || currentUrl === '/home') {
        isHomePage = true;
      }
      //console.log(isHomePage);
      if (mediaQuery.matches && isHomePage === true) {
        if (carousel.classList.contains('active-carousel')) {
          carousel.dispose();
          carousel.classList.remove('active-carousel');
          //console.log('I destroy you!!!');
        }
      } else {
        let activeCarouselId = '#'+carouselId;
        //console.log(activeCarouselId);
        carousel.classList.add('active-carousel');
        const activeCarousel = new Carousel(activeCarouselId, {
          ride: 'carousel',
        });
        //console.log('Carousel powers: Activate!!!');
      }
    });
  }

  mediaQuery.addEventListener('DOMContentLoaded', showHideCarousel);
  mediaQuery.addEventListener('resize', showHideCarousel);

  showHideCarousel(mediaQuery);
})();
 *
 */
